import { render } from "./App.vue?vue&type=template&id=6eb7bd44"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6eb7bd44&lang=scss"

import exportComponent from "C:\\dev\\brc-results\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__